
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam",
      function () {
        return require("private-next-pages/pam/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam"])
      });
    }
  